import * as angular from 'angular';

import { IDispatcherService, IDispatcher, ITicketTypesActionsService } from '../';
import { TicketType } from '../../models';

export interface ITicketTypesStoreService {
    getAll: (force?: boolean) => angular.IPromise<TicketType[]>;
}

export interface ITicketTypesActionDispatcherService extends IDispatcherService<ITicketTypesStoreService> { }

export class TicketTypesActionDispatcherService implements ITicketTypesActionDispatcherService {
    static serviceId = 'ticketTypesActionDispatcherService';

    static $inject = ['ticketTypesActionsService'];

    constructor(private _actionService: ITicketTypesActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<ITicketTypesStoreService> {
        return {
            dispatcher: {
                getAll: (force?: boolean) => dispatch(this._actionService.getAll(force)),
            }
        };
    }
}